import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import ReactGA from "react-ga4";
import { Blocks } from 'react-loader-spinner'
import { CustomProvider } from 'rsuite';
import "./App.css";
import 'rsuite/dist/rsuite.min.css';
import "bootstrap/dist/css/bootstrap.css";
import { isLocalAdminPreview } from './localPreview/mode';

const LocalAdminPreview = process.env.NODE_ENV === 'development'
  ? React.lazy(() => import('./localPreview/LocalAdminPreview'))
  : null;

const VirtuaaliApuriTemplate = React.lazy(() => {
  return import('./openReactTemplate/VirtuaaliApuriTemplate');
});

export default function SurveyJSReactApplication() {
  // Removed root path script loading - no longer needed since root redirects to hallintapaneeli

  // Set page title
  useEffect(() => {
    document.title = 'Hallintapaneeli';
  }, []);

  // Define allowed pages
  const allowedPages = [
    'myynti',
    'soita',
    'demo',
    'tarjous',
    'asennus',
    'widgetEditor',
    'hallintapaneeli',
    'hello',
    'master',
    'test_bot',
    'form_render',
    'form_gallery',
    'bot_gallery',
    'admin',
    'email-builder',
    'email-buillder',
    'mainoskuvageneraattori',
    'ad-image-generator',
    'kutsu',
    'unohdin-salasanan',
  ];

  // rsuite's useToaster().push() is a silent no-op without a CustomProvider ancestor
  // (no `toasters` in context). No locale/theme props: rsuite defaults stay unchanged.
  if (isLocalAdminPreview()) {
    return (
      <CustomProvider>
        <React.Suspense fallback={<p>Ladataan paikallista esikatselua…</p>}><LocalAdminPreview /></React.Suspense>
      </CustomProvider>
    );
  }

  return (
    <CustomProvider>
      <Router>
        <Switch>
          {/* Redirect root to hallintapaneeli */}
          <Route exact path="/">
            <Redirect to="/hallintapaneeli" />
          </Route>

          {/* All allowed pages use VirtuaaliApuriTemplate */}
          <Route path={`/:page(${allowedPages.join('|')})`}>
            <React.Suspense fallback={<Blocks visible={true} height="160" width="160" ariaLabel="blocks-loading" wrapperClass="blocks-wrapper" />}>
              <VirtuaaliApuriTemplate />
            </React.Suspense>
          </Route>

          {/* Catch-all: redirect any other path to hallintapaneeli */}
          <Route path="*">
            <Redirect to="/hallintapaneeli" />
          </Route>
        </Switch>
      </Router>
    </CustomProvider>
  )
}


